// extracted by mini-css-extract-plugin
export var cardIcon = "_67-4";
export var checkboxCard = "_67-0";
export var checkboxCardSelected = "_67-3";
export var disabled = "_67-1";
export var outerBorder = "_67-2";
export var spacerMedium = "_67-7";
export var spacerSmall = "_67-6";
export var spacerXsmall = "_67-5";